import { combineReducers } from 'redux';
import feedReducer from './feedReducer';
import {modalReducer} from './modalReducer';
import storyReducer from './storyReducer';
import exploreReducer from './exploreReducer';
import fleekStateReducer from './fleekStateReducer';
import webMetaData from '../../reducers/shared/webMetaData';
import brandsPageReducer from './brandsPageReducer';
import popup from '../../reducers/shared/Popup'

const fleekRootReducer = combineReducers({
     feed: feedReducer,
     story: storyReducer,
     modal: modalReducer,
     explore: exploreReducer,
     state: fleekStateReducer,
     metaData: webMetaData,
     brandsPage: brandsPageReducer,
     popup: popup
  // Add additional reducers here
});

export default fleekRootReducer;
